(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-exit-intent"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (sessionStorage.getItem('ssExitShown')) return;
  var modal = document.getElementById('ss-exit');
  if (!modal) return;
  function show(){
    if (sessionStorage.getItem('ssExitShown')) return;
    modal.classList.add('ss-exit-open');
    sessionStorage.setItem('ssExitShown','1');
  }
  document.addEventListener('mouseleave', function(e){ if (e.clientY <= 10) show(); });
  setTimeout(show, 45000);
})();

  } catch(e) { console.error(e); }
})();
})();
